import { useLocation, Link } from 'react-router-dom';
import '../styles/Confirmation.css'; // Confirmation ki CSS

function Confirmation() {
  const location = useLocation();
  const booking = location.state?.booking;

  if (!booking) {
    return (
      <div className="confirmation-page-wrapper">
        <div className="conf-bg-glow conf-bg-glow-1"></div>
        <div className="conf-bg-glow conf-bg-glow-2"></div>
        <div className="conf-container">
          <div className="conf-card error">
            <div className="conf-icon-wrapper">
              <span className="conf-icon">⚠️</span>
            </div>
            <h2 className="conf-title error">No Booking Found</h2>
            <p className="conf-subtitle">Something went wrong. Please try registering again.</p>
            <div className="conf-actions">
              <Link to="/events" className="conf-btn primary">
                Browse Events →
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="confirmation-page-wrapper">
      {/* Animated Background Glows */}
      <div className="conf-bg-glow conf-bg-glow-1"></div>
      <div className="conf-bg-glow conf-bg-glow-2"></div>

      <div className="conf-container">
        <div className="conf-card success">
          {/* Icon */}
          <div className="conf-icon-wrapper">
            <span className="conf-icon">✅</span>
          </div>
          
          {/* Title */}
          <h2 className="conf-title">Registration Successful! 🎉</h2>
          <p className="conf-subtitle">
            Your team has been successfully registered for the event
          </p>

          {/* Booking ID */}
          <div className="conf-booking-id">
            <span>Booking ID</span>
            <strong>#{booking.id}</strong>
          </div>

          {/* Booking Details */}
          <div className="conf-details">
            <h3 className="conf-details-title">📋 Booking Details</h3>
            
            <div className="conf-detail-row">
              <span className="conf-detail-label">Team Name</span>
              <span className="conf-detail-value">{booking.teamName}</span>
            </div>
            
            <div className="conf-detail-row">
              <span className="conf-detail-label">Captain</span>
              <span className="conf-detail-value">{booking.captainName}</span>
            </div>
            
            <div className="conf-detail-row">
              <span className="conf-detail-label">Email</span>
              <span className="conf-detail-value">{booking.email}</span>
            </div>
            
            <div className="conf-detail-row">
              <span className="conf-detail-label">Phone</span>
              <span className="conf-detail-value">{booking.phone}</span>
            </div>
            
            <div className="conf-detail-row">
              <span className="conf-detail-label">Event</span>
              <span className="conf-detail-value">{booking.eventTitle}</span>
            </div>
            
            <div className="conf-detail-row">
              <span className="conf-detail-label">Date</span>
              <span className="conf-detail-value">{booking.eventDate}</span>
            </div>
            
            <div className="conf-detail-row">
              <span className="conf-detail-label">Players</span>
              <span className="conf-detail-value">
                {booking.players.filter(p => p.trim()).join(', ')}
              </span>
            </div>
            
            <div className="conf-detail-row">
              <span className="conf-detail-label">Registered</span>
              <span className="conf-detail-value">
                {new Date(booking.registeredAt).toLocaleString()}
              </span>
            </div>
          </div>

          {/* Actions - Only Browse More Events */}
          <div className="conf-actions">
            <Link to="/events" className="conf-btn primary">
              🔍 Browse More Events →
            </Link>
          </div>

          {/* Note */}
          <div className="conf-note">
            <p>A confirmation email has been sent to your registered email address.</p>
            <p>Please save your Booking ID for future reference.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;